import { useLanguageStore, toContentLanguage } from "@/stores/language";
import { t, type TranslationKey } from "@/lib/i18n";

export function useTranslation() {
  const language = useLanguageStore((s) => s.language);
  return {
    t: (key: TranslationKey, params?: Record<string, string | number>) =>
      t(key, language, params),
    /** UI language — three values. Use for chrome. */
    language,
    /**
     * Content language — two values. Use when picking which version of a
     * video's title / description / recipe / media track to show; zh-Hant and
     * zh-Hans viewers share the same Chinese content.
     */
    contentLanguage: toContentLanguage(language),
  };
}
